<template>
  <div class="block">
    <header>
      <div class="myBalance">
        <span class="title">我的余额</span>
        <span class="value">¥ {{ balance }}</span>
      </div>
      <div class="links">
        <el-link :underline="false" @click="checkRule">兑换规则 ></el-link>
        <el-link :underline="false" @click="jumpOrderList">查看订单 ></el-link>
      </div>
    </header>
    <el-tabs v-model="activeName" @tab-click="handleTabsChange">
      <el-tab-pane
        :label="`全部${allCount ? '(' + allCount + ')' : ''}`"
        name="1"
        v-loading="dataLoading"
      >
      </el-tab-pane>
      <el-tab-pane label="销量" name="2" v-loading="dataLoading"></el-tab-pane>
      <el-tab-pane label="价格" name="3" v-loading="dataLoading"></el-tab-pane>
    </el-tabs>
    <div class="productionCont">
      <div
        class="productionCard"
        v-for="(item, index) in totalList"
        :key="index"
        @click="jumpDetail(item)"
      >
        <div class="imgWrap">
          <img :src="item.image" />
          <span>{{ item.sell_num || 0 }}人已兑换</span>
        </div>
        <h4 :title="item.name">{{ item.name }}</h4>
        <div class="desc">{{ item.description }}</div>
        <div class="footer">
          <div class="money">{{ item.price }}</div>
          <div class="stock">
            库存{{
              item.stock === 9999 ? item.stock : item.stock - item.sell_num
            }}
          </div>
        </div>
        <div
          v-if="item.month_buy"
          class="cornerMark"
          :class="{ disabled: item.buy_num == item.month_buy }"
        >
          每月限购{{ item.buy_num || 0 }}/{{ item.month_buy }}
        </div>
      </div>
    </div>
    <div class="data-filter-page">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        :page-sizes="[8]"
        :page-size="pagination.page_size"
        @current-change="allDataPageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/home.mixins';
export default {
  mixins: [mixins],
};
</script>
<style src="../../../style/common-pc.scss" lang="scss" scoped></style>
<style src="../../../style/common-pc-tab.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.container .block {
  padding: 0;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  background: #f7f7fa;
  width: 992px;
  height: 120px;
  padding: 0 30px;
  margin-bottom: 24px;
  .myBalance {
    .title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #262626;
      line-height: 34px;
      margin-right: 20px;
    }
    .value {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3b9aff;
      line-height: 34px;
    }
  }
  .links {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3b9aff;
    line-height: 22px;
    display: flex;
    justify-content: flex-end;
    .el-link {
      margin-left: 34px;
      color: #3b9aff;
    }
  }
}
::v-deep .el-tabs {
  .el-tabs__item {
    font-size: 16px;
  }
}
.el-tab-pane {
  min-height: 0;
}
.productionCont {
  padding: 7px 50px 0;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  .productionCard {
    width: 174px;
    height: 269px;
    border: 1px solid #ffcc40;
    border-radius: 4px;
    position: relative;
    padding: 12px;
    margin-right: 34px;
    margin-bottom: 22px;
    cursor: pointer;
    .cornerMark {
      position: absolute;
      top: -1px;
      right: -1px;
      background: #3b9aff;
      border-radius: 0px 4px 0px 11px;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      width: 88px;
      height: 22px;
      text-align: center;
      &.disabled {
        background-color: #ccc;
      }
    }
    .imgWrap {
      width: 150px;
      height: 150px;
      background: #fef4de;
      position: relative;
      margin: auto;
      img {
        width: 150px;
        height: 150px;
      }
      span {
        position: absolute;
        right: 0;
        bottom: 0;
        // padding: 4px;
        width: 140px;
        text-align: right;
        height: 11px;
        font-size: 11px;
        line-height: 11px;
        padding: 8.5px 5px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        background: rgba(0, 0, 0, 0.6);
        box-sizing: content-box;
      }
    }
    h4 {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 17px;
      margin-top: 6px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .desc {
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 16px;
      min-height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 2px;
    }
    .footer {
      margin-top: 6px;
      border-top: 1px solid #ebebeb;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-top: 3px;
      .money {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff5533;
        line-height: 33px;
        position: relative;
        margin-left: 14px;
        &::before {
          display: block;
          width: 8px;
          height: 14px;
          line-height: 14px;
          overflow: visible;
          content: '¥';
          color: #ff5533;
          font-size: 14px;
          position: absolute;
          left: -14px;
          bottom: 8px;
        }
      }
      .stock {
        height: 16px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fd9b21;
        line-height: 16px;
        margin-bottom: 3px;
      }
    }
  }
}
</style>
